import axios from 'axios';

const API_BASE_URL = `${import.meta.env.VITE_API_BASE_URL}/api`;

export interface JobLevel {
    id: number;
    name: string;
}

export interface JobRole {
    id: number;
    name: string;
    levels: JobLevel[];
}

const jobRoleService = {
    async getAllJobRoles(): Promise<JobRole[]> {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_BASE_URL}/job-roles`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },
};

export default jobRoleService;
